var map = {
	"./back.svg": "RN8c",
	"./biyan.svg": "vAnV",
	"./chenggong.svg": "OdZf",
	"./chengshiliandan.svg": "dXGO",
	"./daochu.svg": "5k29",
	"./img.svg": "HnV6",
	"./jinhuodan_shijianchaxun.svg": "sCn4",
	"./menu.svg": "dH9r",
	"./play.svg": "ufmG",
	"./saoyisao.svg": "TlrJ",
	"./shipin.svg": "HG71",
	"./shouye_shezhi.svg": "s/Fo",
	"./sousuo.svg": "MhH+",
	"./weidianliang.svg": "3+D8",
	"./weixinzhifu.svg": "auoJ",
	"./yidianliang.svg": "rp9U",
	"./zhengyan.svg": "lU9u",
	"./zhifubaozhifu.svg": "zEO4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 4